var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseSection', {
    attrs: {
      "id": _vm.section.key,
      "is-visible": _vm.isSectionVisible,
      "is-modified": _vm.isDataChanged,
      "section": _vm.section
    },
    on: {
      "onSectionSaveClick": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "section",
      fn: function fn() {
        return [_c('v-card-text', {
          staticClass: "mt-4"
        }, [_c('div', {
          staticClass: "mb-5"
        }, [_c('v-simple-table', {
          staticClass: "mt-5",
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn() {
              return [_c('tbody', _vm._l(_vm.loanStructure, function (loanStructureItem, idx) {
                return _c('tr', {
                  key: idx
                }, [_c('td', [_c('v-text-field', {
                  staticClass: "pa-5",
                  attrs: {
                    "dense": "",
                    "type": "text",
                    "placeholder": "Loan amount",
                    "label": "Loan amount",
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  model: {
                    value: loanStructureItem.loan_emount,
                    callback: function callback($$v) {
                      _vm.$set(loanStructureItem, "loan_emount", $$v);
                    },
                    expression: "loanStructureItem.loan_emount"
                  }
                })], 1), _c('td', [_c('v-combobox', {
                  staticClass: "pa-5",
                  attrs: {
                    "items": _vm.termOptions,
                    "label": "Term",
                    "dense": "",
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  model: {
                    value: loanStructureItem.term,
                    callback: function callback($$v) {
                      _vm.$set(loanStructureItem, "term", $$v);
                    },
                    expression: "loanStructureItem.term"
                  }
                })], 1), _c('td', [_c('v-text-field', {
                  staticClass: "pa-5",
                  attrs: {
                    "dense": "",
                    "type": "text",
                    "placeholder": "Rate, % pa",
                    "label": "Rate, % pa",
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  model: {
                    value: loanStructureItem.rate,
                    callback: function callback($$v) {
                      _vm.$set(loanStructureItem, "rate", $$v);
                    },
                    expression: "loanStructureItem.rate"
                  }
                })], 1), _c('td', [_c('v-text-field', {
                  staticClass: "pa-5",
                  attrs: {
                    "dense": "",
                    "type": "text",
                    "placeholder": "Repayment, $",
                    "label": "Repayment, $",
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  model: {
                    value: loanStructureItem.repayment_amount,
                    callback: function callback($$v) {
                      _vm.$set(loanStructureItem, "repayment_amount", $$v);
                    },
                    expression: "loanStructureItem.repayment_amount"
                  }
                })], 1), _c('td', [_c('v-select', {
                  staticClass: "pa-5",
                  attrs: {
                    "dense": "",
                    "items": _vm.periodOptions,
                    "label": "Period",
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  model: {
                    value: loanStructureItem.period,
                    callback: function callback($$v) {
                      _vm.$set(loanStructureItem, "period", $$v);
                    },
                    expression: "loanStructureItem.period"
                  }
                })], 1), _c('td', [_c('v-icon', {
                  attrs: {
                    "disabled": _vm.FIELDS_DISABLED
                  },
                  on: {
                    "click": function click($event) {
                      $event.preventDefault();
                      return _vm.removeLoanStructure(idx);
                    }
                  }
                }, [_vm._v(" mdi-delete ")])], 1)]);
              }), 0)];
            },
            proxy: true
          }])
        }), _c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": _vm.FIELDS_DISABLED
          },
          on: {
            "click": _vm.addLoanStructure
          }
        }, [_vm._v(" Add new ")])], 1)])];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }